import './bloquegrid.scss';
import React, { useContext, useEffect, useState } from 'react';
import { ArticulosTallesContext } from '../../../../../context/articulostalles/ArticulosTallesContext';
import { DataGrid } from '@mui/x-data-grid';
import TallesModal from '../../../../talles/tallesModal/tallesModal';

const TalleGrid = ({ datoIdArticulo, dataCarac, addCarac, removeCarac }) => {
  const {
    getArtTallesPanelData,
    postArtTalleData,
    deleteArtTalleData
  } = useContext(ArticulosTallesContext);
  const [listaCaracDataGrid, setListaCaracDataGrid] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedDesc, setSelectedDesc] = useState(null);

  const [items, setItems] = useState([]);
  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Estados para la paginación
  let numPagina=1;
  let filas=200;
  // Estado del buscador
  const [searchTerm, setSearchTerm] = useState("");
  const [searchIDArt, setSearchIDArt] = useState(datoIdArticulo || null);

  // Variables para los campos repetidos
  const idArt = 'art_Id';
  const idCarac = 'talle_id';
  const descData = 'su_talle.tal_descripcion';
  const caracName = 'Talle';

  // Variables para funciones repetidas
  const add = postArtTalleData;
  const list = getArtTallesPanelData;
  const remove = deleteArtTalleData;

  // Variables para arrayTemporal
  const tipo = 'talle';
  const arrayCarac = dataCarac[tipo];
  const addItemTemp = addCarac;
  const removeItemTemp = removeCarac;

  useEffect(() => {
    if (datoIdArticulo) {
      setSearchIDArt(datoIdArticulo)
    }
    fetchData();
  }, [datoIdArticulo, arrayCarac, searchIDArt, searchTerm, filas, numPagina]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      if (datoIdArticulo) {
        const data = await list(searchIDArt, searchTerm, numPagina, filas);
        if (data && data.colores) { 
          setListaCaracDataGrid(data.talles);
        } else {
          setListaCaracDataGrid([]); // Establece un valor predeterminado si no hay datos
        }
      } else {
        setListaCaracDataGrid([...arrayCarac]);
      }
    } catch (error) {
      console.error("Error al cargar datos:", error);
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleAdd = async () => {
    // Verificar si el talle ya existe en el array
    let caracDataExiste = '';
    let caracArrayTempExiste = '';
    if (datoIdArticulo) {
      caracDataExiste = listaItems.some(item => item[idCarac] === selectedId);
    }
    else {
      caracArrayTempExiste = arrayCarac.some(item => item[idCarac] === selectedId);
    }


    if (caracArrayTempExiste || caracDataExiste ) {
      alert("El item seleccionado ya ha sido agregado.");
      return; // No agregar si ya existe
    }
    
    
    if (selectedId && datoIdArticulo) {
      let dataNew = {
        [idArt]: datoIdArticulo,
        [idCarac]: selectedId,
      };
      try {
        add(dataNew);
        
        await fetchData();
        setSelectedId(null);
        setSelectedDesc(null);
        setItems('');
      } catch (error) {
        console.error("Error al agregar el artículo con talle:", error);
      }
    } else if (!datoIdArticulo) {
      // Si no hay `datoIdArticulo`, agregar temporalmente a `arrayCarac`
      let n = arrayCarac.length + 1;
      const newItem = {
        id: n,
        [idArt]: n,
        [idCarac]: selectedId,
        [descData]: selectedDesc,
      };
      addItemTemp(tipo, newItem);
      setSelectedId(null);
      setSelectedDesc(null);
      setItems('');
    } else {
      alert("Por favor, seleccione un talle antes de agregar.");
    }
  };


  const handleDelete = async (id) => {
    setIsLoading(true); // Inicio de la operación
    try {
      if (datoIdArticulo) {
        await remove(id); 
        await fetchData(); // Solo después de eliminar, actualizamos el DataGrid
      } else {
        // Caso de eliminación en datos temporales
        removeItemTemp(tipo, id);
        await fetchData();
      }
    } catch (error) {
      console.error("Error al eliminar el artículo:", error);
      // Puedes agregar aquí alguna retroalimentación al usuario, como un alert o mensaje
    } finally {
      setIsLoading(false); // Operación completada
    }
  };
  

  // Función para acceder a valores anidados dinámicamente
  const getNestedProperty = (obj, keyPath) => {
    return keyPath.split('.').reduce((acc, key) => acc && acc[key], obj);
  };

  const columns = [
    { field: 'index', headerName: 'N°', width: 40 },
    { field: 'id', headerName: 'ID', width: 40, hide: true },
    { field: idArt, headerName: 'Articulo', width: 150, hide: true },
    { field: 'carac_id', headerName: caracName.concat(' ID'), width: 150, hide: true }, // Ocultamos el ID del talle si no es necesario mostrarlo
    { field: 'caracNombre', headerName: caracName, width: 180 }, // Mostramos la descripción del talle
  ];

  const rows = (datoIdArticulo ? listaCaracDataGrid : arrayCarac).map((item, index) => ({
    index: index + 1,
    id: item.id, // Generar ID único si no existe
    idArt: item[idArt],
    carac_id: item[idCarac],
    caracNombre: datoIdArticulo?getNestedProperty(item, descData) :item[descData]|| 'No definido', // Acceso dinámico anidado
  }));
  
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 60,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <button type="button" onClick={() => handleDelete(params.row.id)}>
              ❌
            </button>
          </div>
        );
      },
    },
  ];
  return (
    <div className="formGrid">
      <div className="searchContainer">
        <TallesModal
          selectID={setSelectedId}
          selectDESC={setSelectedDesc}
        />
        <div className="buttonContainer">
          {selectedId && (
            <button type="button" onClick={handleAdd}>
              ➕
            </button>
          )}
        </div>
        
      </div>
      <div style={{ height: 300, width: '100%' }}>
        {!isLoading && rows.length === 0 ? (
          <div>No hay datos para mostrar.</div>
        ) : (
          <DataGrid
            rows={rows}
            columns={columns.concat(actionColumn)}
            rowsPerPage={rows.length}
            disableSelectionOnClick
            hideFooter
            scrollbarSize={20}
            getRowId={(row) => row.id || `${row.idArt}-${row.carac_id}`}
            sx={{
              '& .MuiDataGrid-virtualScroller': {
                overflowX: 'scroll',
              },
              height: '100%',
            }}
            loading={isLoading}
          />
        )}
      </div>
    </div>
  );
}
export default TalleGrid;
